import TrackingNumberForm from './_form'
import template from './edit.pug'

export default Vue.extend({
  template: template(),
  components: {
    TrackingNumberForm
  },
  data() {
    return {
      ready: false,
      data: {},
      errors: {}
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.$setPageTitle(this.$t('trackingNumbers.edit.title'))
        this.loadData()
      }
    }
  },

  methods: {
    loadData() {
      this.ready = false
      API.trackingNumbers.show(this.$route.params.id).then(response => {
        console.log(response)
        this.data = response
        this.ready = true

        this.$setBreadcrumbs([
          {
            label: this.$t('breadcrumbs.trackingNumbers.index'),
            route: {
              name: 'tracking-numbers-index'
            }
          },
          {label: this.$t('breadcrumbs.trackingNumbers.edit', {name: this.data.name}), route: {}}
        ])
      })
    },

    updateTrackingNumbers(data) {
      API.trackingNumbers.update(this.$route.params.id, data).then(() => {
        this.$notifications.success(this.$t('trackingNumbers.edit.succesfullyUpdated'))
        this.$router.push({name: 'tracking-numbers-index'})
      }, errors => {
        this.errors = errors
      })
    }
  }
})
